// Permanently deleting a meeting.
//
// SHORT, and deliberately not the shared DeleteConfirmModal — the same judgement
// TaskDeleteModal makes and for the same reason. That dialog makes you type the record's
// name because deleting a retainer or a job destroys billing history that cannot be
// reconstructed; a meeting is a single row with nothing beneath it, so the same guard
// would be ceremony, and ceremony asked for routinely stops being read.
//
// WHAT IT KEEPS is the part that matters at any size: the meeting is NAMED at the top, the
// button is red so it does not look like the cancel beside it, and a refused delete leaves
// the dialog open with the error, since nothing was destroyed and it can be retried.
//
// WHAT IT ADDS is the sentence pointing at the other door. Delete and cancel are two
// different acts that arrive at the same moment — "this meeting is not happening" — and
// only one of them keeps the record. The dialog says which is usually wanted rather than
// leaving the choice to whichever button is nearer.
import { useState } from 'react';
import he from '../../i18n/he';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import { ErrorText } from '../../components/Loader';
import { meetingLabel } from './MeetingChip';

export default function MeetingDeleteModal({ meeting, onClose, onDeleted }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const confirm = async () => {
    setBusy(true);
    setError(null);
    try {
      await onDeleted();
    } catch (e) {
      setError(e);
      setBusy(false);
    }
  };

  return (
    <Modal title={he.calendar.deleteMeeting} onClose={onClose}>
      <p>{he.common.deleteQuestion}</p>

      <div className="modal-subject">
        <strong>{meetingLabel(meeting)}</strong>
        <div className="muted small-note">{meeting.start_time}–{meeting.end_time}</div>
      </div>

      <p className="delete-warning">{he.common.deleteIrreversible} {he.calendar.deleteExplain}</p>

      <div className="actions">
        <Button
          onClick={confirm}
          disabled={busy}
          variant="danger"
        >
          {busy ? he.common.deleting : he.common.deletePermanently}
        </Button>
        <Button variant="subtle" onClick={onClose} disabled={busy}>{he.common.cancel}</Button>
      </div>

      {error && <ErrorText error={error} />}
    </Modal>
  );
}
